import React, { useState } from "react";
import { Table, Tag, Input, Typography, Spin } from "antd";
import { useQuery } from "@tanstack/react-query";
import { useIsMobile } from "./hooks/useIsMobile";
import qs from "qs";
import { ColumnsType } from "antd/es/table";
import { API } from "./services/api";

type DartArticle = {
  company: string;
  title: string;
  link: string;
  time: string;
  type: string;
};

interface Props {}

const fetchDarts = async ({
  page,
  limit,
  sortField,
  sortOrder,
  search,
}: {
  page: number;
  limit?: number;
  sortField?: string;
  sortOrder?: string;
  search?: {
    title?: string;
    company?: string;
  };
}) => {
  try {
    const url =
      search?.title || search?.company
        ? "/total-kind-articles/search"
        : "/total-kind-articles";

    const paramsRaw = {
      page,
      limit,
      sortField,
      sortOrder,
      title: search?.title,
      company: search?.company,
    };

    //없는 값들은 Filter
    const params = qs.stringify(
      Object.fromEntries(
        Object.entries(paramsRaw).filter(([key, value]) => value)
      )
    );
    const response = await API.get(url + "?" + params);
    return response.data;
  } catch (error) {
    throw new Error("Network response was not ok");
  }
};

const TotalKind: React.FC<Props> = () => {
  const isMobile = useIsMobile();
  const [page, setPage] = useState<number>(1);
  const [limit] = useState<number>(100);

  const [sortField, setSortField] = useState<string>("");
  const [sortOrder, setSortOrder] = useState<string>("");

  const [keywordFilterForDart, setKeywordFilterForDart] = useState<string>("");
  const [keywordCompanyFilter, setKeywordCompanyFilter] = useState<string>("");

  const { data, isLoading } = useQuery({
    queryKey: [
      "dartArticles",
      {
        page,
        limit,
        sortField,
        sortOrder,
        keywordFilterForDart,
        keywordCompanyFilter,
      },
    ],
    queryFn: () =>
      fetchDarts({
        page,
        limit: 100,
        sortField,
        sortOrder,
        search: {
          title: keywordFilterForDart,
          company: keywordCompanyFilter,
        },
      }),
    refetchOnWindowFocus: false, // 윈도우 포커스 시 데이터 리패칭 여부
  });

  const dartArticles = data?.data?.contents || [];
  const totalDartArticles = data?.data?.total || 0;

  const handleSearch = (value: string) => {
    setPage(1);
    setKeywordFilterForDart(value);
  };

  const handleKeywordCompanyFilter = (value: string) => {
    setPage(1);
    setKeywordCompanyFilter(value);
  };

  console.log(dartArticles);

  return (
    <div style={{ flex: 1 }}>
      <div
        style={{
          display: "flex",
          gap: 16,
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <Typography.Title
          level={5}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 0,
          }}
        >
          Kind 공시
        </Typography.Title>
        <Typography.Text style={{ color: "gray" }}>
          2023.09.08 이후 데이터입니다 (매일 밤 10시 업데이트)
        </Typography.Text>
      </div>
      <div
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "center",
          marginBottom: 20,
        }}
      >
        <Input.Search
          onChange={(e) => handleKeywordCompanyFilter(e.target.value)}
          style={{ width: 500 }}
          placeholder="회사명"
        />
        <Input.Search
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 500 }}
          placeholder="제목 검색"
        />
      </div>

      <Table
        size="small"
        columns={
          [
            {
              title: "회사",
              dataIndex: "company",
              width: isMobile ? 100 : 150,
              sorter: true,
            },
            {
              title: "제목",
              dataIndex: "title",
              render: (text, record) => (
                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                  <a
                    href={record.link}
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(
                        record.link,
                        "popupWindow",
                        "width=1000,height=800,scrollbars=yes,resizable=yes"
                      );
                    }}
                  >
                    {text}
                  </a>
                  {record.type ? <Tag>{record.type}</Tag> : <div />}
                </div>
              ),
            },
            {
              title: "시간",
              dataIndex: "time",
              sorter: true,
            },
          ] as ColumnsType<DartArticle>
        }
        dataSource={dartArticles}
        loading={{
          spinning: isLoading,
          indicator: (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: 300,
                gap: 20,
              }}
            >
              <Spin tip="데이터를 불러오는 중입니다... " size="large" />
              <Typography.Text
                style={{
                  width: 300,
                  display: "block",
                }}
              >
                Kind 과거 데이터를 불러오는 중입니다...
              </Typography.Text>
            </div>
          ),
        }}
        onChange={(pagination, filters, sorter) => {
          // @ts-ignore
          if (sorter.field && sorter.order) {
            console.log(sorter);
            // @ts-ignore
            setSortField(sorter.field as string);
            // @ts-ignore
            setSortOrder(sorter.order === "ascend" ? "asc" : "desc");
          } else {
            setSortField("time");
            setSortOrder("desc");
          }
        }}
        pagination={{
          showSizeChanger: false,
          onChange: (page) => setPage(page),
          pageSizeOptions: ["10", "20", "50", "100"],
          pageSize: 100,
          total: totalDartArticles,
        }}
      />
    </div>
  );
};

export default TotalKind;
